module.exports = __webpack_public_path__ + "media/corporate-image/logo_machinelife-360944c28c25d0267fc21a83205221f4.png";